import axios from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;

const getAuthHeaders = () => ({
    Authorization: 'Bearer ' + localStorage.getItem('user-jwt'),
});

export const createPlantingCycle = async (data) => {
    const response = await axios.post(`${apiUrl}/planting-cycles`, data, { headers: getAuthHeaders() });
    return response.data;
};

export const getPlantingCycleDetails = async (id) => {
    const response = await axios.get(`${apiUrl}/planting-cycles/${id}`, { headers: getAuthHeaders() });
    return response.data;
};

export const getPlantingCyclesByCrop = async (cropId) => {
    const response = await axios.get(`${apiUrl}/planting-cycles/by-crop/${cropId}`, { headers: getAuthHeaders() });
    return response.data;
};

export const completeCyclePhase = async (cycleId, phaseLogId) => {
    const response = await axios.post(
        `${apiUrl}/planting-cycles/${cycleId}/phases/complete`,
        { phaseLogId },
        { headers: getAuthHeaders() }
    );
    return response.data;
};

export const getCycleDailyStats = async (plantingCycleId) => {
    const response = await axios.get(`${apiUrl}/planting-cycles/${plantingCycleId}/daily-stats`, { headers: getAuthHeaders() });
    return response.data;
};

export const registerHarvest = async (cycleId, data) => {
    const response = await axios.post(`${apiUrl}/planting-cycles/${cycleId}/harvests`, data, { headers: getAuthHeaders() });
    return response.data;
};

export const updateHarvest = async (cycleId, harvestId, data) => {
    const response = await axios.patch(`${apiUrl}/planting-cycles/${cycleId}/harvests/${harvestId}`, data, { headers: getAuthHeaders() });
    return response.data;
};

export const getCycleHarvests = async (cycleId) => {
    const response = await axios.get(`${apiUrl}/planting-cycles/${cycleId}/harvests`, { headers: getAuthHeaders() });
    return response.data;
};

export const finishCycle = async (cycleId, data) => {
    const response = await axios.post(`${apiUrl}/planting-cycles/${cycleId}/finish`, data || {}, { headers: getAuthHeaders() });
    return response.data;
};

export const abandonCycle = async (cycleId, data) => {
    const response = await axios.post(`${apiUrl}/planting-cycles/${cycleId}/abandon`, data, { headers: getAuthHeaders() });
    return response.data;
};
